import { Component, OnInit } from '@angular/core';
import { Recorder } from '../../entities/recorder';
import { TimelineStore } from '../../timeline/timeline.store';
import { PlaybackConfig } from '../../interfaces/playback-config';
import { Player } from '../../entities/player';
import { RecorderStore } from '../../stores/recorder.store';

@Component({
  selector: 'app-record-buttons',
  templateUrl: './record-buttons.component.html',
  styleUrls: ['./record-buttons.component.styl'],
})
export class RecordButtonsComponent implements OnInit {
  repeat = false;

  constructor(
    private timelineStore: TimelineStore,
    private recorderStore: RecorderStore,
    private recorder: Recorder,
    private player: Player,
  ) {
  }

  ngOnInit() {
  }

  get undoButtonDisabled(): boolean {
    return this.player.playback ||
      this.recorder.recording ||
      this.recorderStore.historyData.appliedTransactionsNumber === 0;
  }

  onUndoButtonClick() {
    this.recorderStore.undo();
  }

  get redoButtonDisabled(): boolean {
    return this.player.playback ||
      this.recorder.recording ||
      this.recorderStore.historyData.rollbackTransactionsNumber === 0;
  }

  onRedoButtonClick() {
    this.recorderStore.redo();
  }

  onRepeatButtonClick() {
    this.repeat = !this.repeat;
  }

  get repeatButtonIsDisabled(): boolean {
    return this.player.playback ||
      this.recorder.recording;
  }

  get playback(): boolean {
    return this.player.playback;
  }

  get playbackButtonIsDisabled(): boolean {
    return this.recorderStore.recordData.length === 0 || this.recorder.recording;
  }

  onPlaybackButtonClick() {
    this.togglePlayback();
  }

  private togglePlayback() {
    if (this.player.playback) {
      this.player.stop();
    } else {
      this.player.play(this.playbackConfig);
    }
  }

  private get playbackConfig(): PlaybackConfig {
    const currentPosition = this.timelineStore.currentPosition;
    const recordLength = this.recorderStore.recordData.length;

    const startPosition = currentPosition < recordLength ? currentPosition : 0;
    const endPosition = recordLength;
    const repeat = this.repeat;

    return {startPosition, endPosition, repeat};
  }

  onRecordingButtonClick() {
    this.toggleRecording();
  }

  get recordingButtonIsDisabled(): boolean {
    return this.player.playback;
  }

  get recording(): boolean {
    return this.recorder.recording;
  }

  private toggleRecording() {
    this.recording ? this.stopRecording() : this.startRecording();
  }

  private startRecording() {
    this.recorder.startRecording(this.timelineStore.recordingConfig);
  }

  private stopRecording() {
    this.recorder.stopRecording();
  }
}



// WEBPACK FOOTER //
// ./src/app/rec/components/record-buttons/record-buttons.component.ts